export default __webpack_public_path__ + "static/media/logo.1d9b6937.png";